<template>
    <div>
        <b-modal id="detalleDeCosto1" footer-class="extra-light" hide-header hide-footer>
            <p class="text-right">
                <button class="PC-btn--closeModal" @click="$bvModal.hide('detalleDeCosto1')">
                    <i class="icon-Cerrar icon-close-rounded-outline"></i>
                </button>
            </p>
            <p v-if="!specialDetail" class="PC-text--size18 PC-text--bold">{{$t('language.posadasCorporate.detalleCosto.detalleCosto')}}</p>
            <p v-if="specialDetail" class="PC-text--size18 PC-text--bold">{{$t('language.posadasCorporate.detalleCosto.detailReser')}}</p>
            

            <div role="tablist">
                <b-card class="mb-1 PC-card--collapsible">
                    <b-card-header header-tag="header" role="tab">
                        <p v-if="specialDetail" class="PC-text--size16 PC-text--bold">{{$t('language.posadasCorporate.reservacionesModificar.datosReservacion')}}</p>
                    </b-card-header>
                    <b-card-body>
                    <div class="w-100 align-top">
                        
 <div v-if="specialDetail">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.reservacionesModificar.numConfirmacion')}}:</span></div>
                <div class="costosTable"><span>{{noSCon}}</span></div>
              </div>
              <div v-if="specialDetail">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.modificacionReservaciones.nameG')}}:</span></div>
                <div class="costosTable"><span>{{guestName}}</span></div>
              </div>
              <div v-if="specialDetail">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.modificacionReservaciones.colleague')}}:</span></div>
                <div class="costosTable"><span>{{colleague}}</span></div>
              </div>
              <div v-if="specialDetail">
                <div class="costosTable"><span class="PC-text--semibold">Hotel:</span></div>
                <div class="costosTable"><span>{{hotelName}}</span></div>
              </div>
              <div v-if="specialDetail">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.modificacionReservaciones.totalNights')}}:</span></div>
                <div class="costosTable"><span>{{dataInfoCosto.nights}}</span></div>
              </div>
              <div v-if="specialDetail">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.sidebarReserva.requerimientos')}}:</span></div>
                <div class="costosTable"><span>{{requirementS}}</span></div>
              </div>
           


                        <div >
                        <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.diasReservacion')}}:</span></div>
                        <div class="costosTable"><span>{{dataInfoCosto.arrivalDate}} - {{dataInfoCosto.departureDate}}</span></div>
                        </div>
                        <div>
                        <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.tipoTarifa')}}:</span></div>
                        <div class="costosTable">
                            <span>{{dataInfoCosto.rateType}} 
                            </span>
                        </div>
                        </div>
                        <div class="flex flex-align-end">          
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.tarifaHabitacionPor')}} {{dataInfoCosto.nights}} {{dataInfoCosto.nights===1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches')}}:</span>
                            </div>
                            <div v-if="!masaka && !enableConfir" class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:dataInfoCosto.totalRateWithoutTaxes)}}</span></div>
                            <div v-if="masaka || enableConfir" class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:dataInfoCosto.totalCostWithoutTaxesWihtSupplements)}}</span></div>
                        </div>

                        <div v-if="specialDetailI && totalSuppl != 0.00"> 
                <div  class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou1')}}:</span></div>
                <div class="costosTable"><span>$ {{totalSuppl}}</span></div>
              </div>
              <div v-if="specialDetailI && totalSuppl != 0.00">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou2')}}:</span></div>
                <div class="costosTable"><span>$ {{totalTaxSuppl}}</span></div>
              </div>

                <div v-if="specialDetailI && finalDen && totalSupplII != 0.00">
                <div  class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou1')}}:</span></div>
                <div class="costosTable"><span>$ {{totalSupplII}}</span></div>
              </div>
              <div v-if="specialDetailI && finalDen && totalTaxSuppl != 0.00">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou2')}}:</span></div>
                <div class="costosTable"><span>$ {{totalTaxSuppl}}</span></div>
              </div>

 <div >
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.ivaA')}}:</span></div>
                <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:addTax)}}</span></div>
              </div>
        <div>
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.ISH')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:addISH)}}</span></div>
                        </div>
                        <div >
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.impuestosHabitacion')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:dataInfoCosto.totalTaxes )}}</span></div>
                        </div>     
                        <div>
                        <div class="costosTableTotal">
                            <span class="PC-text--bold totalCompleto">{{$t('language.posadasCorporate.generals.totalEstanciaImpuestos')}} {{dataInfoCosto.nights}} {{dataInfoCosto.nights===1?$t('language.posadasCorporate.generals.noche'):$t('language.posadasCorporate.generals.noches')}}:</span><br>
                            <span class="PC-text--size12 PC-color--grayBrownish">
                                {{dataInfoCosto.totalRooms}} {{dataInfoCosto.totalRooms===1?$t('language.posadasCorporate.detalleCosto.habitacion'):$t('language.posadasCorporate.detalleCosto.habitaciones')}}<br>
                            </span> 
                        </div>
                        <div class="costosTableTotal">                                                  
                            <span class="span-multiline text-right" style="margin-top:8px">
                                <br><span class="PC-text--bold PC-text--size17 totalCompleto">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:dataInfoCosto.totalRateWithTaxes)}} <span class="moneda">{{dataInfoCosto.currencyCode}}</span></span>
                            </span>
                        </div>
                        </div>
                    </div>
                    </b-card-body>
                </b-card>
                <b-card class="mb-1 PC-card--collapsible" v-for="(listCost, index) of dataInfoCosto.ratesDetailResponses" :key="index">
                    <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle="'noche' + index"><b>{{$t('language.posadasCorporate.detalleCosto.nNoche')}} {{index + 1}}</b></b-button>
                    </b-card-header>
                    <b-collapse :id="'noche' + index" :accordion="'Noche' + index" role="tabpanel">
                    <b-card-body>
                        <div class="w-100 align-top">
                        <div>
                    
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.diaReservacion')}}:</span></div>
                            <div class="costosTable"><span>{{listCost.reservationDate}}</span></div>
                        </div>
                        <div>
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.tipoTarifa')}}:</span></div>
                            <div class="costosTable"><span>{{listCost.rateType}} <span v-if="banTooltips" class="icon-info PC-color--colorBase3 cursor" @click="[$bvModal.hide('detalleDeCosto1'), openModalTarifa(listCost, index) ]"></span></span></div>
                        </div>
                        <div v-if="!masaka && !enableConfir"  class="flex flex-align-end">
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.tarifaHabitacionNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones: !realMuzukashi  ? globalFunctions.numberFormat(listCost.roomCostAsRate , 2, '.', ',') :  globalFunctions.numberFormat(listCost.amountMandatory + listCost.roomCostAsRate , 2, '.', ',')  )}}</span></div>  <!--globalFunctions.numberFormat(listCost.rateSupplementTaxesResponseList.amount + listCost.roomCostAsRate, 2, '.', ',') : globalFunctions.numberFormat(listCost.roomCostAsRate, 2, '.', ',')   listCost.roomCostWithoutTaxes by listCost.roomCostWithoutTaxes -->
                        </div>
                        <div v-if="masaka || enableConfir"  class="flex flex-align-end">
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.tarifaHabitacionNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:  globalFunctions.numberFormat(listCost.roomCostWithoutTaxes , 2, '.', ',')   )}}</span></div>  <!--globalFunctions.numberFormat(listCost.rateSupplementTaxesResponseList.amount + listCost.roomCostAsRate, 2, '.', ',') : globalFunctions.numberFormat(listCost.roomCostAsRate, 2, '.', ',')   listCost.roomCostWithoutTaxes by listCost.roomCostWithoutTaxes //    roomCostAsRate (this includes the sum) and asRate does not -->
                        </div>
                  
                   
          
           <div v-if=" index == 0 && specialDetailI && everyNightS + firstNightS != 0.00">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou1')}}:</span></div>
                <div class="costosTable"><span>$ {{globalFunctions.numberFormat( everyNightS + firstNightS , 2, '.', ',')}}</span></div>
              </div>

              <div v-if=" index != 0 && specialDetailI && everyNightS  != 0.00">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou1')}}:</span></div>
                <div class="costosTable"><span>$ {{globalFunctions.numberFormat( everyNightS , 2, '.', ',')}}</span></div>
              </div>


              <div v-if=" index == 0 && specialDetailI && everyNightTS + firstNightTS != 0.00">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou2')}}:</span></div>
                <div class="costosTable"><span>$ {{globalFunctions.numberFormat( everyNightTS + firstNightTS, 2, '.', ',')}}</span></div>
              </div>

                <div v-if=" index != 0 && specialDetailI && everyNightTS != 0.00">
                <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.hontou2')}}:</span></div>
                <div class="costosTable"><span>$ {{globalFunctions.numberFormat( everyNightTS , 2, '.', ',')}}</span></div>
              </div>


                         <div>
                  <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.ivaA')}}:</span></div>
                    
                  <div  v-if="(listCost.ratesTaxesList.length != 0 && listCost.ratesTaxesList.length != null) ? true : false" class="costosTable">
                      <span  v-if="(listCost.ratesTaxesList.length == 1 ) ? true : false">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.ratesTaxesList[0].taxCode == "IVA" ?listCost.ratesTaxesList[0].taxAmount + ( mandatorySuppIVAPerNight[index] != undefined ? mandatorySuppIVAPerNight[index].totalAmount : 0 ):0, 2, '.', ','))}}</span>             
                      <span  v-if="(listCost.ratesTaxesList.length == 2 ) ? true : false">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.ratesTaxesList[0].taxCode == "IVA" ?listCost.ratesTaxesList[0].taxAmount + ( mandatorySuppIVAPerNight[index] != undefined ? mandatorySuppIVAPerNight[index].totalAmount : 0 ):listCost.ratesTaxesList[1].taxCode == "IVA" ?listCost.ratesTaxesList[1].taxAmount + ( mandatorySuppIVAPerNight[index] != undefined ? mandatorySuppIVAPerNight[index].totalAmount : 0 ) :0, 2, '.', ','))}}</span>
                      <span  v-if="(listCost.ratesTaxesList.length > 2 ) ? true : false">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:0.00)}}</span>
                    
                      </div>
                </div>


                             <div>
                  <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.ISH')}}:</span></div>
                  <div  v-if="(listCost.ratesTaxesList.length != 0 && listCost.ratesTaxesList.length != null) ? true : false" class="costosTable">
                      <span  v-if="(listCost.ratesTaxesList.length == 1 ) ? true : false">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.ratesTaxesList[0].taxCode == "ISH" ?listCost.ratesTaxesList[0].taxAmount:0, 2, '.', ','))}}</span>
                      <span  v-if="(listCost.ratesTaxesList.length == 2 ) ? true : false">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.ratesTaxesList[0].taxCode == "ISH" ?listCost.ratesTaxesList[0].taxAmount:listCost.ratesTaxesList[1].taxCode == "ISH" ?listCost.ratesTaxesList[1].taxAmount:0, 2, '.', ','))}}</span>
                      <span  v-if="(listCost.ratesTaxesList.length > 2 ) ? true : false">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:0.00)}}</span>
                    
                      </div>
                </div>
                <!-- Piece -->

           <div v-if=" index == 0 && specialDetailI && everyNightTS + firstNightTS != 0.00 && !masaka && !enableConfir">
                   <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.impuestosNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.taxes +everyNightTS + firstNightTS, 2, '.', ','))}}</span></div>
              </div>

               <div v-if=" index == 0 && specialDetailI && everyNightS + firstNightS == 0.00 && !masaka && !enableConfir">
                          <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.impuestosNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.taxes , 2, '.', ','))}}</span></div>
              </div>

              <div v-if=" index != 0 && specialDetailI && everyNightTS  != 0.00 && !masaka && !enableConfir">
                                    <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.impuestosNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.taxes + everyNightTS , 2, '.', ','))}}</span></div>
              </div>


             

              <div v-if=" index != 0 && specialDetailI && everyNightS == 0.00 && !masaka && !enableConfir">
                                    <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.impuestosNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.taxes , 2, '.', ','))}}</span></div>
              </div>

                <!-- piece -->

                              <div v-if="masaka || enableConfir">
                            <div class="costosTable"><span class="PC-text--semibold">{{$t('language.posadasCorporate.detalleCosto.impuestosNoche')}}:</span></div>
                            <div class="costosTable"><span>$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat(listCost.taxes, 2, '.', ','))}}</span></div>
                        </div> 
                        <div>
                            <div class="costosTable">
                            <span class="PC-text--bold">{{$t('language.posadasCorporate.detalleCosto.totalEstanciaNoche')}}:</span><br>
                            </div>
                            <div v-if="index == 0 && totalSuppl != 0.00" class="costosTable">
                            <span class="span-multiline text-right">
                                <span class="PC-text--bold PC-text--size17">$  {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat((listCost.roomCostWithTaxes ) + everyNightS + firstNightS + everyNightTS + firstNightTS, 2, '.', ','))}} <span class="moneda">{{dataInfoCosto.currencyCode}}</span></span>
                                <span class="PC-text--size12 PC-color--grayBrownish">{{$t('language.posadasCorporate.detalleCosto.ivaIncluido')}}</span>
                            </span>
                            </div>
                            <div v-if="index == 0 && totalSuppl == 0.00" class="costosTable">
                            <span class="span-multiline text-right">
                                <span class="PC-text--bold PC-text--size17">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat((listCost.roomCostWithTaxes ) , 2, '.', ','))}} <span class="moneda">{{dataInfoCosto.currencyCode}}</span></span>
                                <span class="PC-text--size12 PC-color--grayBrownish">{{$t('language.posadasCorporate.detalleCosto.ivaIncluido')}}</span>
                            </span>
                            </div>


                                           <div v-if="index != 0 && totalSuppl != 0.00" class="costosTable">
                            <span class="span-multiline text-right">
                                <span class="PC-text--bold PC-text--size17">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat((listCost.roomCostWithTaxes ) + everyNightS +everyNightTS  , 2, '.', ','))}} <span class="moneda">{{dataInfoCosto.currencyCode}}</span></span>
                                <span class="PC-text--size12 PC-color--grayBrownish">{{$t('language.posadasCorporate.detalleCosto.ivaIncluido')}}</span>
                            </span>
                            </div>
                                               <div v-if="index != 0 && totalSuppl == 0.00" class="costosTable">
                            <span class="span-multiline text-right">
                                <span class="PC-text--bold PC-text--size17">$ {{((dataInfoCosto.userClientID===pyp||dataInfoCosto.userClientID===pypsa||!showRates)&&dataInfoCosto.tabActive===1?guiones:globalFunctions.numberFormat((listCost.roomCostWithTaxes )  , 2, '.', ','))}} <span class="moneda">{{dataInfoCosto.currencyCode}}</span></span>
                                <span class="PC-text--size12 PC-color--grayBrownish">{{$t('language.posadasCorporate.detalleCosto.ivaIncluido')}}</span>
                            </span>
                            </div>
                        </div>
                        </div>
                    </b-card-body>
                    </b-collapse>
                </b-card>
            </div>

            <div class="col-12 col-md-6 float-right mt-2">
                <button @click="$bvModal.hide('detalleDeCosto1'); find() ">
                {{$t('language.posadasCorporate.detalleCosto.entendido')}}
                </button>
            </div>
        </b-modal>

        <!--tooltips-->
        <modal class="modalTarifario" v-if="banMod1" @close="closeModalTarifa(1)" maxHeight="max-h-85vh" maxWidth="max-w-500">
            <template slot="header">
                <p   class="tituloModal"> 
                    {{ rateDescriptionText }}
                </p>
                
            </template>
            <template slot="body">
                <p   class="Ta-left">
                    {{ rateBenefitsText + ' ' + rateBenefitsRestrictions }}
                </p>
                <hr>
                <div class="row">
                    <span class="rateStrong col-12">{{$t('language.posadasCorporate.detalleCosto.comisionTasaBase')}}</span>
                    <div class="col-6 rate">{{$t('language.posadasCorporate.detalleCosto.contrato')}}</div>
                    <div class="col-4 textoPop">{{modalListCoste.commissionResponse.contract}}</div>
                    <div class="col-6 rate">{{$t('language.posadasCorporate.detalleCosto.cantidadBase')}}</div>
                    <div class="col-4 textoPop">{{globalFunctions.numberFormat(modalListCoste.commissionResponse.baseAmount, 2, '.', ',')}}</div>
                    <div class="col-6 rate">{{$t('language.posadasCorporate.detalleCosto.comision')}}</div>
                    <div class="col-4 textoPop">{{modalListCoste.commissionResponse.commissionPercentage}} %</div>
                    <div class="col-6 rate">{{$t('language.posadasCorporate.detalleCosto.cantidadComision')}}</div>
                    <div class="col-4 textoPop">{{globalFunctions.numberFormat(modalListCoste.commissionResponse.commissionAmount, 2, '.', ',')}}</div>
                </div>
            </template>
            <template slot="footer">
                <button type="button" class="secondary-button order-2 order-lg-1" @click="[closeModalTarifa(1), $bvModal.show('detalleDeCosto1')]" aria-label="Close modal">
                    {{$t('language.posadasCorporate.detalleCosto.volver')}}
                </button>
            </template>
        </modal>
              
                       <modal class="modalTarifario" v-if="banMod2" @close="closeModalTarifa(2)" maxHeight="max-h-85vh" maxWidth="max-w-500">
            <template slot="header">
                <p  class="tituloModal"> 
                    {{ rateDescriptionText }}
                </p>
                
            </template>
            <template slot="body">
                <p  class="Ta-left">
                    {{ rateBenefitsText + ' ' + rateBenefitsRestrictions }}    
                </p>
                
            </template>
            <template slot="footer">
                <button type="button" class="secondary-button order-2 order-lg-1" @click="[closeModalTarifa(2), $bvModal.show('detalleDeCosto1')]" aria-label="Close modal">
                    {{$t('language.posadasCorporate.detalleCosto.volver')}}
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
    import * as GlobalFunctions from '../../utils/GlobalFunctions';
    import SecureLS from 'secure-ls';
    import Modal from '../addons/Modal.vue';
    export default {
    components: {
        Modal,
    },
    name: 'DetalleCostos',
    data() {
        return {
            mandatorySuppIVAPerNight: [],
            addingMandatory: false,
            realMuzukashi: false,
            amountMandatory: 0,
            tarifaWHabitacion: true,
            enableConfir: false,
            masaka: false,
            plusDeChambres: 1,
            encire: 0,
            jeLir: false,
            totalSupplII: 0,
            finalDen: false,
            firstNightS: 0,
            everyNightS: 0,
                        firstNightTT: 0,
            everyNightTT: 0,
                        firstNightTS: 0,
            everyNightTS: 0,
specialDetailI: true,
totalTaxSuppl: 0,
totalSuppl: 0,
          addTax: "",
          addISH: 0,
          aluguel: "",  
inSupp: "",
inAdd: "",
        suppTax: "",
        supple: "",
noSCon: "",
guestName: "",
colleague: "",
hotelName: "",
requirementS: "",
            specialDetail: true,
            totalStayWithOptionalSupplements: 0,
                isRateDescription : true,
                isRateBenefits : true,
                israteRestrictions : true,
              rateDescriptionText :  '',
                rateBenefitsText :  '',
                rateBenefitsRestrictions : '',
            infoCosto: null,
            ls: new SecureLS({encodingType: 'aes'}),            
            pyp: 'PYP', //no cambiar este valor
            pypsa: 'PYPSA', //no cambiar este valor
            guiones: '-------', //no cambiar este valor
            globalFunctions: GlobalFunctions,
            banTooltips: false,
            banMod1: false, //modal corta
            noTitleModal: false,
            noBodyModal: false,
            banMod2: false, // modal completa
            modalListCoste: null,
            showRates: null,
            dataInfoCosto: {
                userClientID: null,
                arrivalDate: null,
                departureDate: null,
                rateType: null,
                totalRateWithoutTaxes: null,
                totalTaxes: null,
                totalSupplement: null,
                subTotalRateTaxes: null,
                nights: null,
                totalRateWithTaxes: null,
                nights: null,
                ratesDetailResponses: [],
                totalRooms:null,
                currencyCode: null,
                benefitsRestrictions: null,
                tabActive:null,
                 totalCostWithoutTaxesWihtSupplements: 0
            },
            isModalTarifa: false,
            isModalTarifaFamiliares: false,
        }
    },
    watch: {
 costDetailCounter() {
        this.updateBusquedaPorTarifa()
    },
    },
    computed: {
             costDetailCounter() {
        return this.$store.getters.gettingCostDetailCounter
    },
    },
    methods: {
        find(){
        },
        updateBusquedaPorTarifa() {

      this.infoCosto =  this.ls.get('updateCostDetail')
      if(this.infoCosto.data.habitacion.totalRooms != "" && this.infoCosto.data.habitacion.totalRooms != null && this.infoCosto.data.habitacion.totalRooms != 0) {
          this.plusDeChambres = this.infoCosto.data.habitacion.totalRooms
      }
if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes == null) {
    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = 0
}
        if (this.infoCosto.data.localStor === 'datosHabHotSelected') {
            this.dataInfoCosto.arrivalDate = this.globalFunctions.convertBeautifulDate((this.infoCosto.data.habitacion.arrivalDate==undefined||this.infoCosto.data.habitacion.arrivalDate==null||this.infoCosto.data.habitacion.arrivalDate==''?this.infoCosto.data.habitacion.beautiDateInput:this.infoCosto.data.habitacion.arrivalDate), this.ls.get('Language').data);
            this.dataInfoCosto.departureDate = this.globalFunctions.convertBeautifulDate((this.infoCosto.data.habitacion.departureDate==undefined||this.infoCosto.data.habitacion.departureDate==null||this.infoCosto.data.habitacion.departureDate==''?this.infoCosto.data.habitacion.beautiDateOutput:this.infoCosto.data.habitacion.departureDate), this.ls.get('Language').data);
            var currentLocation = window.location;
                    if(this.$store.getters.gettingLang == 'es' && this.dataInfoCosto.rateType == 'Public Rate') {
                                this.dataInfoCosto.rateType = 'TarifaPública'
                    }  
                    if(this.$store.getters.gettingLang == 'en' && this.dataInfoCosto.rateType == 'Tarifa Pública') {
                            this.dataInfoCosto.rateType = 'Public Rate'
                    }
                    
                     if(this.$store.getters.gettingLang == 'es' && this.dataInfoCosto.rateType == 'Negotiated Rate') {
                                this.dataInfoCosto.rateType = 'Tarifa Negociada'
                    }  
                    if(this.$store.getters.gettingLang == 'en' && this.dataInfoCosto.rateType == 'Tarifa Negociada') {
                            this.dataInfoCosto.rateType = 'Negotiated Rate'
                    }
             
                this.dataInfoCosto.totalRateWithoutTaxes = GlobalFunctions.numberFormat((this.infoCosto.data==null?'':this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes), 2, '.', ',');
                this.dataInfoCosto.totalCostWithoutTaxesWihtSupplements = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalCostWithoutTaxesWihtSupplements, 2, '.', ',');
               console.log("VALUE Detalle Costo::   this.dataInfoCosto.totalRateWithoutTaxes"+  this.dataInfoCosto.totalRateWithoutTaxes); 
             var currI = window.location;
                this.dataInfoCosto.totalTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalTaxes +this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes, 2, '.', ',');
                 
                this.dataInfoCosto.totalSupplement = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalSupplement, 2, '.', ',');
                this.dataInfoCosto.subTotalRateTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.subTotalRateTaxes, 2, '.', ',');
                this.dataInfoCosto.nights = this.infoCosto.data.hotel.negotiatedRatesDetailPrice.nights;
                  if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes == null) {
                 this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
             }
      var currentLocationII = window.location;
           this.dataInfoCosto.totalRateWithTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes + ( this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes * this.plusDeChambres), 2, '.', ',');
                 // Set supplements avec nouvelle fenetre
this.totalSuppl = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes - this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes, 2, '.', ',');

this.totalTaxSuppl = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes, 2, '.', ',');
// Set supplements avec nouvelle fenetre
if(this.ls.get('generalUp') && this.ls.get('generalUp') != null && this.ls.get('generalUp') != "") {
 this.totalSuppl = GlobalFunctions.numberFormat(this.ls.get('generalSuppl'), 2, '.', ',');
 this.totalTaxSuppl = GlobalFunctions.numberFormat(this.ls.get('generalSupplIm'), 2, '.', ',');
} 
// IVA: Total de depenses
var currentLocationIII = window.location;
       if(currentLocationIII.pathname == "/reservaciones-cancelada" || currentLocationIII.pathname == "/busqueda-seguimiento" || currentLocationIII.pathname == "/busqueda-avanzada" || currentLocationIII.pathname == "/movimientos-del-dia" || currentLocationIII.pathname == "/reservaciones-modificar" || this.$store.getters.getClearExtraCosts) {
           this.totalSupplII = this.totalSuppl
           this.totalSuppl = 0
           this.finalDen = true
       }
var totalIVAW = 0
for(var i = 0; i < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; i++) {
    for(var j = 0; j < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList.length; j++){
        if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxCode == "IVA") {
             totalIVAW +=   this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxAmount 
        }       
    }
}


var totalISH = 0
for(var i = 0; i < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; i++) {
    for(var j = 0; j < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList.length; j++){
        if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxCode == "ISH") {
             totalISH +=   this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxAmount 
        }       
    }
}

    let mandatorySuppIVA = 0
                this.mandatorySuppIVAPerNight = []
                for(var i = 0; i < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; i++){
                    if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList !== undefined &&
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList.length > 0) {
                    let suppIVAPerNight = 0
                     for(var j = 0; j < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList.length; j++){
                        if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList !== undefined &&
                        this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList.length > 0) {
                            for(var z = 0; z < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList.length; z++){
                             if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList[z].taxCode == "IVA"){
                                 mandatorySuppIVA += this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList[z].taxAmount
                                 suppIVAPerNight += this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList[z].taxAmount
                                 this.mandatorySuppIVAPerNight.push({
                                    id: i,
                                    totalAmount: suppIVAPerNight
                                })
                             }
                            }
                        }
                     }
                    }
                }
this.addTax = GlobalFunctions.numberFormat(totalIVAW + mandatorySuppIVA, 2, '.', ',');

this.addISH = GlobalFunctions.numberFormat(totalISH, 2, '.', ',');
// IVA
            this.dataInfoCosto.ratesDetailResponses = this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses;
          var indAmount = 0
            if(this.dataInfoCosto.ratesDetailResponses.length != 0 && this.dataInfoCosto.ratesDetailResponses != null) {
                        for(var j = 0; j < this.dataInfoCosto.ratesDetailResponses.length ; j++) {
                                     if(this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList.length != 0 && this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList != null) {
                                       indAmount = 0
                                               for(var i = 0; i < this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList.length ; i++) {
                                                    indAmount +=   this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList[i].amount
                                       this.dataInfoCosto.ratesDetailResponses[j].amountMandatory = indAmount
                                       this.realMuzukashi = true
                                               }
                                     }
                        }
            }
           this.dataInfoCosto.totalRooms = this.infoCosto.data.habitacion.totalRooms;
                this.dataInfoCosto.currencyCode = this.infoCosto.data.habitacion.currencyCode;
                this.dataInfoCosto.benefitsRestrictions = this.infoCosto.data.hotel.benefitsRestrictions;


             if(this.infoCosto.data.whichRates == 'Negociadas' && this.infoCosto.data.hotel.benefitsRestrictions == null && this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse == null) {
                this.banTooltips = false;
             } else {
                  if (this.infoCosto.data.hotel.benefitsRestrictions != null && this.infoCosto.data.whichRates == 'Negociadas') {
                this.banTooltips = true;
                this.rateDescriptionText =  this.dataInfoCosto.benefitsRestrictions.rateDescription
                this.rateBenefitsText =  this.dataInfoCosto.benefitsRestrictions.benefits
                this.rateBenefitsRestrictions = this.dataInfoCosto.benefitsRestrictions.restrictions
                } else {
                    if(this.infoCosto.data.whichRates == 'Negociadas') {
this.rateDescriptionText =  ''
                this.rateBenefitsText =  ''
                this.rateBenefitsRestrictions = ''
                this.isRateDescription = false
                this.isRateBenefits = false
                this.israteRestrictions = false
                this.banTooltips = true;
                    }
                
                }

             }  

             if(this.infoCosto.data.whichRates == 'Publicas' && this.infoCosto.data.hotel.benefitsRestrictions == null && this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse == null) {
                this.banTooltips = false;
             } else {
                  if (this.infoCosto.data.hotel.benefitsRestrictions != null && this.infoCosto.data.whichRates == 'Publicas') {
                this.banTooltips = true;
                this.rateDescriptionText =  this.dataInfoCosto.benefitsRestrictions.rateDescription
                this.rateBenefitsText =  this.dataInfoCosto.benefitsRestrictions.benefits
                this.rateBenefitsRestrictions = this.dataInfoCosto.benefitsRestrictions.restrictions
               } else {
                    if(this.infoCosto.data.whichRates == 'Publicas') {
                this.rateDescriptionText =  ''
                this.rateBenefitsText =  ''
                this.rateBenefitsRestrictions = ''
                this.isRateDescription = false
                this.isRateBenefits = false
                this.israteRestrictions = false
                this.banTooltips = true;        // TESTING
                    }
                }
             }
                this.dataInfoCosto.userClientID = this.infoCosto.data.userClientID;
                this.dataInfoCosto.tabActive = this.infoCosto.data.tabActive;

                this.ls.set('rateTypeForReservationRequest', { data:this.infoCosto.data.hotel.negotiatedRatesDetailPrice.rateType} )

                this.showRates = this.ls.get('Profile').data.ratesPermissionsResponse.showRates;
            }
        },
        openModalTarifa(listCost, index){
            this.modalListCoste = listCost;
            if (listCost.commissionableRate) {
                this.banMod1 = true;
            } else {
                this.banMod2 = true;                
            }
        },
        closeModalTarifa(index){
            if (index === 1) {
                this.banMod1 = false;
            }
            if (index === 2) {
                this.banMod2 = false;
            }
        },
    },
    created() {
        this.enableConfir = this.$store.getters.getEnaConfir
         var currIL = window.location;
         if(currIL.pathname == "/reservaciones-modificar" ||currIL.pathname == "/busqueda-avanzada" || currIL.pathname == "/busqueda-seguimiento" || currIL.pathname == "/movimientos-del-dia" || currIL.pathname == "/reservaciones-cancelada") {
             this.masaka = true
         } else {
             this.masaka = false
         }
                 if(currIL.pathname == "/reservaciones-modificar" ||currIL.pathname == "/busqueda-avanzada" || currIL.pathname == "/busqueda-seguimiento" || currIL.pathname == "/reservaciones-modificar-lectura" || currIL.pathname == "/movimientos-del-dia" || this.$store.getters.getExtraTaxes ) { 
                     this.jeLir = true
                this.encire = GlobalFunctions.numberFormat(this.ls.get('updateCostDetail').data.hotel.negotiatedRatesDetailPrice.totalTaxes +this.ls.get('generalSupplIm'), 2, '.', ',');
                    } else {
                     this.jeLir = false
                    }
        // Condi supple
        if(this.ls.get('supleCondi') != null && this.ls.get('supleCondi') != "") {
            this.everyNightS = this.ls.get('supleCondi').extraSupE
            this.everyNightTT = this.ls.get('supleCondi').extraToSE
            this.everyNightTS =this.ls.get('supleCondi').extraSupIE


        }
        if(this.ls.get('supleCondiOneFirstNight') != null && this.ls.get('supleCondiOneFirstNight') != "") {
                 this.firstNightS = this.ls.get('supleCondiOneFirstNight').extraSupE
                        this.firstNightTT = this.ls.get('supleCondiOneFirstNight').extraToSE
                        this.firstNightTS = this.ls.get('supleCondiOneFirstNight').extraSupIE
        }
        // Condi supple

        this.noSCon = this.ls.get("extraDetailS").noSCon
this.guestName = this.ls.get("extraDetailS").guestName
this.colleague = this.ls.get("extraDetailS").colleague
this.hotelName = this.ls.get("extraDetailS").hotelName
this.requirementS = this.ls.get("extraDetailS").requirementS

var currentUrl = window.location.pathname;
if( currentUrl == "/movimientos-del-dia" || currentUrl == "/busqueda-seguimiento" || currentUrl == "/busqueda-avanzada") {
        this.specialDetail = true
} else {
        this.specialDetail = false
}
if( currentUrl == "/busqueda-por-tarifa" ) {
        this.specialDetailI = false
} else {
        this.specialDetailI = true
}
      this.infoCosto =  this.ls.get('updateCostDetail')
            if(this.infoCosto.data.habitacion.totalRooms != "" && this.infoCosto.data.habitacion.totalRooms != null && this.infoCosto.data.habitacion.totalRooms != 0) {
          this.plusDeChambres = this.infoCosto.data.habitacion.totalRooms
      }

if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes == null) {
    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = 0
}
        // TEST
        if (this.infoCosto.data.localStor === 'datosHabHotSelected') {
            this.dataInfoCosto.arrivalDate = this.globalFunctions.convertBeautifulDate((this.infoCosto.data.habitacion.arrivalDate==undefined||this.infoCosto.data.habitacion.arrivalDate==null||this.infoCosto.data.habitacion.arrivalDate==''?this.infoCosto.data.habitacion.beautiDateInput:this.infoCosto.data.habitacion.arrivalDate), this.ls.get('Language').data);
            this.dataInfoCosto.departureDate = this.globalFunctions.convertBeautifulDate((this.infoCosto.data.habitacion.departureDate==undefined||this.infoCosto.data.habitacion.departureDate==null||this.infoCosto.data.habitacion.departureDate==''?this.infoCosto.data.habitacion.beautiDateOutput:this.infoCosto.data.habitacion.departureDate), this.ls.get('Language').data);
          var currentLocation = window.location;
                this.dataInfoCosto.rateType = this.infoCosto.data.hotel.negotiatedRatesDetailPrice.rateType;
            
        
                this.dataInfoCosto.totalRateWithoutTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalRateWithoutTaxes, 2, '.', ',');
                this.dataInfoCosto.totalCostWithoutTaxesWihtSupplements = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalCostWithoutTaxesWihtSupplements, 2, '.', ',');
                var currI = window.location;
                if (currI.pathname == '/reservaciones-modificar-lectura' && this.$store.getters.gettingListRequeOpcionalesSeleccionadosForConfir != undefined && this.$store.getters.gettingListRequeOpcionalesSeleccionadosForConfir != null && this.$store.getters.gettingListRequeOpcionalesSeleccionadosForConfir.length != 0) {
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = 0;
                    for (let list of this.$store.getters.gettingListRequeOpcionalesSeleccionadosForConfir) {
                        this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes += list.reqOpcional.rateSupplementTaxesResponseList[0].taxAmount;
                    }
                }
                if (currI.pathname == '/reservaciones-confirmacion' && this.ls.get('opSuEList') != undefined && this.ls.get('opSuEList') != null && this.ls.get('opSuEList') != '') {
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes = 0;
                    for (let list of this.ls.get('opSuEList')) {
                        this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes += list.reqOpcional.rateSupplementTaxesResponseList[0].taxAmount;
                    }
                }
               this.dataInfoCosto.totalTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalTaxes +this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes, 2, '.', ',');
                this.dataInfoCosto.totalSupplement = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalSupplement, 2, '.', ',');
                this.dataInfoCosto.subTotalRateTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.subTotalRateTaxes, 2, '.', ',');
                this.dataInfoCosto.nights = this.infoCosto.data.hotel.negotiatedRatesDetailPrice.nights;
             
             
             
             if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes == null) {
                 this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes = 0
             }
             this.dataInfoCosto.totalRateWithTaxes = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.totalRateWithTaxes + ( this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes * this.plusDeChambres), 2, '.', ',');
     // Set supplements avec nouvelle fenetre
 this.totalSuppl = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTotalRateWithTaxes - this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes, 2, '.', ',');
this.totalTaxSuppl = GlobalFunctions.numberFormat(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.extraTaxes, 2, '.', ',');
// Set supplements avec nouvelle fenetre
if(this.ls.get('generalUp') && this.ls.get('generalUp') != null && this.ls.get('generalUp') != "") {
 this.totalSuppl = GlobalFunctions.numberFormat(this.ls.get('generalSuppl'), 2, '.', ',');
 this.totalTaxSuppl = GlobalFunctions.numberFormat(this.ls.get('generalSupplIm'), 2, '.', ',');

} 
// IVA: Total de depenses
var currentLocationII = window.location;
       if(currentLocationII.pathname == "/reservaciones-cancelada" || currentLocationII.pathname == "/busqueda-seguimiento" || currentLocationII.pathname == "/busqueda-avanzada" || currentLocationII.pathname == "/movimientos-del-dia" || currentLocationII.pathname == "/reservaciones-modificar" || this.$store.getters.getClearExtraCosts) {
          this.totalSupplII = this.totalSuppl
          this.totalSuppl = 0
           this.finalDen = true

       }
var totalIVAWE = 0
for(var i = 0; i < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; i++) {
    for(var j = 0; j < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList.length; j++){
        if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxCode == "IVA") {
             totalIVAWE +=   this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxAmount 
        }       
    }
}


var totalISH = 0
for(var i = 0; i < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; i++) {
    for(var j = 0; j < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList.length; j++){
        if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxCode == "ISH") {
             totalISH +=   this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].ratesTaxesList[j].taxAmount 
        }       
    }
}
    let mandatorySuppIVA = 0
                this.mandatorySuppIVAPerNight = []
                for(var i = 0; i < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses.length; i++){
                    if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList !== undefined &&
                    this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList.length > 0) {
                    let suppIVAPerNight = 0
                     for(var j = 0; j < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList.length; j++){
                        if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList !== undefined &&
                        this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList.length > 0) {
                            for(var z = 0; z < this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList.length; z++){
                             if(this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList[z].taxCode == "IVA"){
                                 mandatorySuppIVA += this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList[z].taxAmount
                                 suppIVAPerNight += this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[i].rateMandatorySupplementResponseList[j].rateSupplementTaxesResponseList[z].taxAmount
                                 this.mandatorySuppIVAPerNight.push({
                                    id: i,
                                    totalAmount: suppIVAPerNight
                                })
                             }
                            }
                        }
                     }
                    }
                }
this.addTax = GlobalFunctions.numberFormat(totalIVAWE + mandatorySuppIVA, 2, '.', ',');
this.addISH = GlobalFunctions.numberFormat(totalISH, 2, '.', ',');

// IVA
     this.dataInfoCosto.ratesDetailResponses = this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses;
      var indAmount = 0
            if(this.dataInfoCosto.ratesDetailResponses.length != 0 && this.dataInfoCosto.ratesDetailResponses != null) {
                        for(var j = 0; j < this.dataInfoCosto.ratesDetailResponses.length ; j++) {
                                     if(this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList.length != 0 && this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList != null) {
                                       indAmount = 0
                                               for(var i = 0; i < this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList.length ; i++) {
                                                    indAmount +=   this.dataInfoCosto.ratesDetailResponses[j].rateMandatorySupplementResponseList[i].amount
                                       this.dataInfoCosto.ratesDetailResponses[j].amountMandatory = indAmount
                                       this.realMuzukashi = true
                                               }
                                     }
                        }
            }

      this.dataInfoCosto.totalRooms = this.infoCosto.data.habitacion.totalRooms;
                this.dataInfoCosto.currencyCode = this.infoCosto.data.habitacion.currencyCode;
                this.dataInfoCosto.benefitsRestrictions = this.infoCosto.data.hotel.benefitsRestrictions;
           if(this.infoCosto.data.whichRates == 'Negociadas' && this.infoCosto.data.hotel.benefitsRestrictions == null && this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse == null) {
                this.banTooltips = false;
             } else {

                  if (this.infoCosto.data.hotel.benefitsRestrictions != null && this.infoCosto.data.whichRates == 'Negociadas') {
                this.banTooltips = true;
                this.rateDescriptionText =  this.dataInfoCosto.benefitsRestrictions.rateDescription
                this.rateBenefitsText =  this.dataInfoCosto.benefitsRestrictions.benefits
                this.rateBenefitsRestrictions = this.dataInfoCosto.benefitsRestrictions.restrictions
              } else {
                    if(this.infoCosto.data.whichRates == 'Negociadas') {
this.rateDescriptionText =  ''
                this.rateBenefitsText =  ''
                this.rateBenefitsRestrictions = ''
                this.isRateDescription = false
                this.isRateBenefits = false
                this.israteRestrictions = false
                this.banTooltips = true;
                    }
                }
             }  
             if(this.infoCosto.data.whichRates == 'Publicas' && (this.infoCosto.data.hotel.benefitsRestrictions == null || this.infoCosto.data.hotel.benefitsRestrictions.length == 0) && this.infoCosto.data.hotel.negotiatedRatesDetailPrice.ratesDetailResponses[0].commissionResponse == null) {
                this.banTooltips = false;
             } else {
                  if (this.infoCosto.data.hotel.benefitsRestrictions != null && this.infoCosto.data.whichRates == 'Publicas') {
                this.banTooltips = true;
                this.rateDescriptionText =  this.dataInfoCosto.benefitsRestrictions.rateDescription
                this.rateBenefitsText =  this.dataInfoCosto.benefitsRestrictions.benefits
                this.rateBenefitsRestrictions = this.dataInfoCosto.benefitsRestrictions.restrictions
            } else {
                    if(this.infoCosto.data.whichRates == 'Publicas') {
                this.rateDescriptionText =  ''
                this.rateBenefitsText =  ''
                this.rateBenefitsRestrictions = ''
                this.isRateDescription = false
                this.isRateBenefits = false
                this.israteRestrictions = false
                this.banTooltips = true;
                    }
                }
             }
                this.dataInfoCosto.userClientID = this.infoCosto.data.userClientID;
                this.dataInfoCosto.tabActive = this.infoCosto.data.tabActive;
                this.ls.set('rateTypeForReservationRequest', {data: this.infoCosto.data.hotel.negotiatedRatesDetailPrice.rateType})
                this.showRates = this.ls.get('Profile').data.ratesPermissionsResponse.showRates;
            }
            // Turn off tooltips
            if( this.specialDetail ) {
                this.banTooltips = false
            }
    },
}
</script>

<style lang="scss">
.icon-info {
    font-size: 20px;
    color: #005a83;
}
.costosTable{
    width: 50%;
    display: inline-block;
    padding-bottom: 5px;
    vertical-align: text-top;
}
.costosTableTotal{
    width: 50%;
    display: inline-block;
    padding-bottom: 5px;
    vertical-align: text-top;
}
span {
    font-size: 14px;
}
.moneda {
    font-size: 13px;
    font-weight: 500;
    display: inline !important;
}
.totalCompleto {
    font-size: 18px;
    font-weight: bold;
}
.icon-Cerrar {
    font-size: 24px;
}
.subtituloPop {
    font-size: 13px;
    font-weight: 500;
}
.marcado{
 font-weight: 500;
}
.tituloModal {
    font-size: 18px;
    font-weight: bold;
  } 
  .subTituloModal {
    font-size: 14px !important;
    margin-top: 15px !important;
    font-weight: bold !important;
  } 
  .rate {
    font-size: 14px !important;
    margin-bottom: 8px !important;
    font-weight: 500 !important;
  } 
  .rateStrong {
    font-size: 14px !important;
    margin-bottom: 8px !important;
    font-weight: bold !important;
  } 
.textoPop {
    font-size: 13px;
}
@media only screen and (max-width: 736px){
    .costosTable{
        width: 100%;
        display: inline-block;
    }
}
</style>
